import { r as registerInstance, h, g as getElement } from './index-5faac9d7.js';
import { c as classnames } from './index-43880fda.js';
import { d as EQdsButtonSize, c as EQdsButtonImportance } from './currency-49e0d692.js';
import { V as VIEW_ON_PLACEHOLDER } from './label-placeholders-68407765.js';
import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { i as isTopRunner } from './guards-ef7bf858.js';
import { V as VARIANTS, R as RouterQdsLinkView, a as CARD_NAME_MAX_HEIGHT_VARIANT_MAP, b as CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP } from './router-qds-link-view-bf71397b.js';
import { R as RouterLinkView } from './router-link-view-dc3c1137.js';
import { i as isAppRoutingEnabled } from './utils-e8b4956e.js';
import './index-39f51a91.js';
import { c as findProductFeedMinimalPrice, d as applyPriceTemplate, w as weeePricesToTextArray } from './price-4641eae8.js';
import { a as format } from './index-67820103.js';
import './_commonjsHelpers-7db8bc26.js';
import './_nodeUtil-549406aa.js';
import './tslib.es6-613ce1cd.js';
import './utils-1b416b6b.js';
import './pes-router-store-498d2799.js';
import './index-54dd34b7.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_Stack-cf94d4e7.js';
import './flatMap-db621f8c.js';
import './_baseFlatten-eecfdcde.js';
import './_arrayLikeKeys-26c55d84.js';
import './isSymbol-8fefec05.js';
import './toString-568546f3.js';
import './_isIndex-3036d479.js';
import './_baseIteratee-17179c5e.js';
import './_getAllKeys-5ba06622.js';
import './hasIn-833a7ad2.js';
import './_baseFor-a28737de.js';

const menuCardCss = ".menu-card{display:block;font-size:14px;line-height:20px;font-weight:400;overflow:hidden}.menu-card__link{cursor:pointer;display:flex;text-decoration:none;color:#626469;position:relative}.menu-card__picture{min-width:80px;height:80px}:host(:not([dir=\"rtl\"])) .menu-card__picture{margin-right:20px}:host([dir=\"rtl\"]) .menu-card__picture{margin-left:20px}.menu-card__brand-image{position:absolute;top:65px;width:60px}:host(:not([dir=\"rtl\"])) .menu-card__brand-image{left:0}:host([dir=\"rtl\"]) .menu-card__brand-image{right:0}.menu-card--small .menu-card__brand-image{display:none}.menu-card__text-content{margin:0;max-width:calc(100% - 100px)}.menu-card--small .menu-card__text-content{max-width:calc(100% - 56px)}.menu-card__name{display:block;margin:0 0 5px;font-weight:700;color:#333333;max-height:40px;overflow:hidden}.menu-card__link:hover .menu-card__name{text-decoration:underline}.menu-card__badge{display:block;margin-bottom:8px}.menu-card__description{margin:0;padding:0;max-height:60px;overflow:hidden}.menu-card__view-all{visibility:hidden;max-width:160px}:host(:not([dir=\"rtl\"])) .menu-card__view-all{margin-left:100px}:host([dir=\"rtl\"]) .menu-card__view-all{margin-right:100px}.menu-card__view-all .menu-card__view-all-link{margin-top:6px;margin-bottom:4px}.menu-card:hover .menu-card__view-all{visibility:visible}:host([dir=\"rtl\"]) .menu-card__view-all-icon{transform:scaleX(-1)}.menu-card__link:hover .menu-card__view-all-icon{top:1px}:host(:not([dir=\"rtl\"])) .menu-card__link:hover .menu-card__view-all-icon{right:5px}:host([dir=\"rtl\"]) .menu-card__link:hover .menu-card__view-all-icon{left:5px}.menu-card--small{font-size:12px;line-height:16px}.menu-card--small .menu-card__picture{min-width:36px;height:36px}";

const MenuCard = class {
  handleMenuCategoryActive(event) {
    var _a, _b;
    const activeCategoryId = event.detail;
    if (activeCategoryId === this.categoryId) {
      (_a = this.descriptionEllipsisRef) === null || _a === void 0 ? void 0 : _a.triggerUpdate();
      (_b = this.nameEllipsisRef) === null || _b === void 0 ? void 0 : _b.triggerUpdate();
    }
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.createDescriptionEllipsisRef = (el) => {
      this.descriptionEllipsisRef = el;
    };
    this.createNameEllipsisRef = (el) => {
      this.nameEllipsisRef = el;
    };
    this.page = undefined;
    this.item = undefined;
    this.categoryId = undefined;
    this.productsFeed = undefined;
    this.viewAllTemplate = undefined;
    this.showViewAll = false;
    this.productRelationsViewProdLabel = undefined;
    this.variant = VARIANTS.DEFAULT;
    this.commerceConnectorSettings = undefined;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  hasCommercialStatus(item) {
    return !isEmpty_1(item === null || item === void 0 ? void 0 : item.commercialStatus) && !!item.commercialStatus.label;
  }
  render() {
    var _a, _b, _c, _d;
    const pageId = (_a = this.item.sourceId) !== null && _a !== void 0 ? _a : this.item.id;
    const redirectUrl = isTopRunner(this.item)
      ? this.item.redirectUrl
      : undefined;
    const { url } = this.item;
    const isTopRunnerWithDefaultVariant = isTopRunner(this.item)
      && this.variant === VARIANTS.DEFAULT;
    const viewAllLinkLabel = redirectUrl
      ? (_b = this.viewAllTemplate) === null || _b === void 0 ? void 0 : _b.replace(VIEW_ON_PLACEHOLDER, this.item.domainName)
      : this.productRelationsViewProdLabel;
    return (h("div", { class: classnames('menu-card', `menu-card--${this.variant}`) }, h(RouterLinkView, { linkClassName: "menu-card__link", page: this.page, pageId: pageId, url: isAppRoutingEnabled() ? '' : redirectUrl || url, target: redirectUrl ? '_blank' : '_self', name: this.item.name, storageName: this.storageName, breadcrumbs: this.breadcrumbs, pageName: this.page.toLocaleUpperCase() }, h("img", { class: "menu-card__picture", src: this.item.pictureUrl, alt: "" }), h("div", { class: "menu-card__text-content" }, h("span", { class: "menu-card__name" }, h("pes-ellipsis", { ref: this.createNameEllipsisRef, maxHeight: CARD_NAME_MAX_HEIGHT_VARIANT_MAP[this.variant], content: this.item.name })), this.hasCommercialStatus(this.item) && (h("pes-badge-wrapper", { class: "menu-card__badge", type: this.item.commercialStatus.status, label: this.item.commercialStatus.label, color: this.item.commercialStatus.color })), ((_c = this.item.badge) === null || _c === void 0 ? void 0 : _c.label) && (h("pes-badge-wrapper", { class: "menu-card__badge", type: this.item.badge.type, label: this.item.badge.label })), h("p", { class: "menu-card__description" }, h("pes-ellipsis", { ref: this.createDescriptionEllipsisRef, maxHeight: CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP[this.variant], content: this.item.description })), this.variant === VARIANTS.SMALL && (h("pes-menu-card-prices", { item: this.item, productsFeed: this.productsFeed, commerceConnectorSettings: this.commerceConnectorSettings }))), isTopRunner(this.item)
      && this.item.brandLogo && (h("img", { class: "menu-card__brand-image", src: this.item.brandLogo.absoluteUrl, alt: (_d = this.item.brandLogo.alt) !== null && _d !== void 0 ? _d : '' }))), isTopRunnerWithDefaultVariant && (h("div", { class: "menu-card__view-all", title: viewAllLinkLabel }, h(RouterQdsLinkView, { linkClassName: "menu-card__view-all-link", page: this.page, pageId: pageId, url: isAppRoutingEnabled() ? '' : redirectUrl || url, target: redirectUrl ? '_blank' : '_self', size: EQdsButtonSize.SMALL, importance: redirectUrl
        ? EQdsButtonImportance.STANDARD
        : EQdsButtonImportance.EMPHASIZED, iconName: redirectUrl ? "arrow-top-right-on-square" : '', name: this.item.name, storageName: this.storageName, breadcrumbs: this.breadcrumbs, pageName: this.page.toLocaleUpperCase() }, viewAllLinkLabel)))));
  }
  get el() { return getElement(this); }
};
MenuCard.style = menuCardCss;

function isCategoryProduct(item) {
  return Boolean('price' in item && item.price && item.currency);
}

const menuCardPricesCss = ":host{display:block}.menu-card-price{display:flex;align-items:center;font-size:14px;line-height:20px;margin-top:4px}.menu-card-price--multi-line{display:block}.menu-card-price__text{color:#333333;font-weight:bold}.menu-card-price__tooltip{width:18px;height:18px}:host(:not([dir=\"rtl\"])) .menu-card-price__tooltip{margin-left:4px}:host([dir=\"rtl\"]) .menu-card-price__tooltip{margin-right:4px}.menu-card-price__label{font-size:12px;line-height:16px}";

const MenuCardPrices = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getMinimalPriceByProductId = (id) => {
      var _a;
      const product = (_a = this.productsFeed) === null || _a === void 0 ? void 0 : _a.find((product) => product.ProductId === id);
      const price = findProductFeedMinimalPrice(product);
      if (!price) {
        return;
      }
      const { options: { countryLanguageCode, priceTemplate }, } = this.commerceConnectorSettings;
      const formattedPrice = format(price, { locale: countryLanguageCode });
      return applyPriceTemplate(formattedPrice, priceTemplate);
    };
    this.item = undefined;
    this.productsFeed = undefined;
    this.commerceConnectorSettings = undefined;
  }
  hasProductsFeed() {
    var _a, _b, _c;
    return ((_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.enablePrice) && ((_c = this.productsFeed) === null || _c === void 0 ? void 0 : _c.length) > 0;
  }
  renderWeeePrices() {
    if (!isCategoryProduct(this.item)) {
      return null;
    }
    return weeePricesToTextArray(this.item.weeePrices).map((text) => h("div", { innerHTML: text }));
  }
  render() {
    var _a, _b;
    if (!isCategoryProduct(this.item) && !this.hasProductsFeed()) {
      return;
    }
    if (this.hasProductsFeed()) {
      const minimalProductPrice = this.getMinimalPriceByProductId(this.item.id);
      return (minimalProductPrice && (h("div", { class: "menu-card-price menu-card-price--multi-line" }, h("div", { class: "menu-card-price__label", innerHTML: this.commerceConnectorSettings.labels.priceFrom }), h("span", { class: "menu-card-price__text", innerHTML: minimalProductPrice }))));
    }
    if (isCategoryProduct(this.item)) {
      const priceText = `${this.item.price}&nbsp;${this.item.currency}`;
      return (h("div", { class: "menu-card-price" }, h("span", { class: "menu-card-price__text", innerHTML: priceText }), !isEmpty_1((_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.weeePrices) !== null && _b !== void 0 ? _b : {}) && (h("pdp-icon-tooltip", { class: "menu-card-price__tooltip", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top" }, this.renderWeeePrices()))));
    }
  }
};
MenuCardPrices.style = menuCardPricesCss;

export { MenuCard as pes_menu_card, MenuCardPrices as pes_menu_card_prices };
